import PropTypes from "prop-types";
import React from "react";
import { MSpinner, TextBlock } from "components/Shared";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

const Notifications = ({ isFetching, items }) => {
  if (isFetching) {
    return <MSpinner/>;
  }

  let title = (items.length === 0)
    ? "There are no new notifications."
    : "There are " + items.length + " notification(s)";
  return (
    <Card className="md-cell md-cell--4 md-cell--right">
      <CardContent><Typography variant="h6">Notifications</Typography></CardContent>
      <CardContent>
        <TextBlock field={title} placeholder="" styleClass="fieldText-bold" />
        <br />
      </CardContent>
    </Card>
  );
};

Notifications.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired
};

export default Notifications;